import { NgModule } from '@angular/core';

import { StoreModule } from '@ngrx/store';

import { LocationsPipeModule } from './pipes/locations-pipe.module';
import { LocationNamePipe } from './pipes/location-name.pipe';
import { locationsReducer } from './store/reducers/locations.reducer';
import { LOCATIONS_FEATURE_KEY } from './constants';

@NgModule({
  imports: [StoreModule.forFeature(LOCATIONS_FEATURE_KEY, locationsReducer), LocationsPipeModule],
  declarations: [],
  exports: [LocationNamePipe],
  providers: [],
})
export class LocationsModule {}
